var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "headbar",
      class: _vm.$store.state.app.collapse
        ? "position-collapse-left"
        : "position-left",
      style: { background: _vm.themeColor },
    },
    [
      _c(
        "span",
        { staticClass: "hamburg" },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-demo",
              attrs: {
                "background-color": _vm.themeColor,
                "text-color": "#fff",
                "active-text-color": _vm.themeColor,
                mode: "horizontal",
              },
            },
            [
              _c(
                "el-menu-item",
                { attrs: { index: "1" }, on: { click: _vm.onCollapse } },
                [_c("hamburger", { attrs: { isActive: _vm.collapse } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "navbar" },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-demo",
              attrs: {
                "default-active": _vm.activeIndex,
                "background-color": _vm.themeColor,
                "text-color": "#fff",
                "active-text-color": "#ffd04b",
                mode: "horizontal",
              },
              on: {
                select: function ($event) {
                  return _vm.selectNavBar()
                },
              },
            },
            [
              _c(
                "el-menu-item",
                {
                  attrs: { index: "1" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/")
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-home fa-lg" })]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "toolbar" },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-demo",
              attrs: {
                "background-color": _vm.themeColor,
                "text-color": _vm.themeColor,
                "active-text-color": _vm.themeColor,
                mode: "horizontal",
              },
            },
            [
              _c("el-menu-item", { attrs: { index: "1" } }),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  directives: [
                    {
                      name: "popover",
                      rawName: "v-popover:popover-lang",
                      arg: "popover-lang",
                    },
                  ],
                  attrs: { index: "2" },
                },
                [
                  _c("li", {
                    staticClass: "fa fa-language fa-lg",
                    staticStyle: { color: "#fff" },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-popover",
                    {
                      ref: "popover-lang",
                      attrs: { placement: "bottom-start", trigger: "click" },
                      model: {
                        value: _vm.langVisible,
                        callback: function ($$v) {
                          _vm.langVisible = $$v
                        },
                        expression: "langVisible",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "lang-item",
                          on: {
                            click: function ($event) {
                              return _vm.changeLanguage("zh_cn")
                            },
                          },
                        },
                        [_vm._v("简体中文")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "lang-item",
                          on: {
                            click: function ($event) {
                              return _vm.changeLanguage("en_us")
                            },
                          },
                        },
                        [_vm._v("English")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-menu-item", {
                directives: [
                  {
                    name: "popover",
                    rawName: "v-popover:popover-message",
                    arg: "popover-message",
                  },
                ],
                attrs: { index: "3" },
              }),
              _vm._v(" "),
              _c("el-menu-item", {
                directives: [
                  {
                    name: "popover",
                    rawName: "v-popover:popover-notice",
                    arg: "popover-notice",
                  },
                ],
                attrs: { index: "4" },
              }),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  directives: [
                    {
                      name: "popover",
                      rawName: "v-popover:popover-personal",
                      arg: "popover-personal",
                    },
                  ],
                  attrs: { index: "5" },
                },
                [
                  _c("span", { staticClass: "user-info" }, [
                    _c("img", { attrs: { src: _vm.logo } }),
                    _vm._v(_vm._s(_vm.user.name)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-popover",
                    {
                      ref: "popover-personal",
                      attrs: {
                        placement: "bottom-end",
                        trigger: "click",
                        "visible-arrow": false,
                      },
                    },
                    [_c("personal-panel", { attrs: { user: _vm.user } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }